import {
  Box,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { memo, useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import {
  ITicketAutomationReceivedRule,
  ITicketAutomationReceivedRuleEstablishment,
} from "../../../services/tasySchedMenu.service";
import { TAppointment } from "../../Schedule/NewSchedule/schema";

interface IEstablishmentProps {
  rule?: ITicketAutomationReceivedRule | null;
}

const formatEstablishment = (
  establishment: ITicketAutomationReceivedRuleEstablishment,
) => ({
  id: establishment.establishmentId,
  name: establishment.establishmentName,
  integrationId: establishment.integrationId,
});

const Establishment: React.FC<IEstablishmentProps> = ({ rule }) => {
  const { control, setValue } = useFormContext<TAppointment>();
  const { t } = useTranslation();
  const establishments =
    rule?.ticketAutomationReceivedRuleEstablishments || [];

  useEffect(() => {
    if (establishments.length === 1) {
      setValue("establishment", formatEstablishment(establishments[0]));
    }
  }, [establishments, setValue]);

  return (
    <Controller
      name="establishment"
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Box>
          <FormLabel>
            {t("page.schedules.newSchedule.steps.establishment.title")}
          </FormLabel>
          <RadioGroup>
            <Stack>
              {establishments.map((establishment) => {
                const option = formatEstablishment(establishment);
                return (
                  <FormControlLabel
                    key={establishment.id}
                    value={option.integrationId}
                    control={
                      <Radio
                        size="small"
                        checked={
                          value?.integrationId === option.integrationId
                        }
                        onChange={() => onChange(option)}
                      />
                    }
                    label={establishment.establishmentName}
                  />
                );
              })}
            </Stack>
          </RadioGroup>
          <Typography variant="body2" color="error">
            {error ? t(error?.message || "") : ""}
          </Typography>
        </Box>
      )}
    />
  );
};

export default memo(Establishment);
